import { Controller } from "@hotwired/stimulus"

// A run's line: its title, then an arrow and what came back. When what came
// back does not fit beside the title it moves under it as a whole, and the
// arrow goes, so no line ends on an arrow or starts with one. Measured, so it
// follows the timeline's width as it changes. A run that failed or is held
// says why in a sentence of its own, so it stays stacked (stacked value).
export default class extends Controller {
  static targets = ["title", "result"]
  static values = { stacked: Boolean }

  connect() {
    this.fit = this.fit.bind(this)
    this.observer = new ResizeObserver(this.fit)
    this.observer.observe(this.element)
    document.fonts?.ready.then(() => { if (this.element.isConnected) this.fit() })
    this.fit()
  }

  disconnect() {
    this.observer?.disconnect()
    this.observer = null
  }

  fit() {
    if (this.stackedValue || !this.hasTitleTarget || !this.hasResultTarget) return

    // Measure with the arrow drawn, so a line that only fits without it stays stacked.
    this.element.removeAttribute("data-stacked")
    const title = this.titleTarget.getBoundingClientRect()
    const result = this.resultTarget.getBoundingClientRect()
    if (result.top > title.top + title.height / 2) this.element.setAttribute("data-stacked", "")
  }
}
